<template>
  <div class="fileSelect">
    <div
      v-if="defaultButton"
      class="addFile d-block pointer"
      :style="{ padding: defaultButton ? '16px 24px' : null }"
      @click="onClickHandler(null)"
    >
      <BaseIcon icon="chat-add_file" color="#52525F" />
    </div>
    <BaseButton
      v-else
      :text="localStorage.translations.pages.common.buttons.dobavit"
      default_icon="chat-add_file"
      @click="onClickHandler(null)"
      :disabled="disabled"
    />
    <input
      class="d-none"
      type="file"
      :accept="accepted"
      v-on:change="handleFileUpload"
      :multiple="multipleFiles"
      ref="chatFilesUploadButton"
    />
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
export default {
  components: {},
  name: 'ChatFilesUploadButton',
  props: {
    defaultButton: { type: Boolean, default: true },
    disabled: Boolean,
  },
  data() {
    return {
      changeFileIndex: null,
    }
  },
  computed: {
    ...mapState('chat', ['chatsConfig']),
    ...mapState('chat/file', ['chatFileSelect']),
    multipleFiles() {
      return this.changeFileIndex !== null ? false : true
    },
    accepted() {
      let acceptedReturn = ''
      for (let key in this.chatsConfig.files.accepted) {
        acceptedReturn =
          acceptedReturn +
          (acceptedReturn.length ? ',' : '') +
          this.chatsConfig.files.accepted[key].join()
      }
      return acceptedReturn
    },
  },
  methods: {
    ...mapActions('chat/file', ['ADD_chatFileSelect']),
    handleFileUpload(e) {
      this.ADD_chatFileSelect({ filesList: e.target.files, changeFileIndex: this.changeFileIndex })
      this.changeFileIndex = null
      this.$refs.chatFilesUploadButton.value = null
    },
    onClickHandler(e) {
      this.changeFileIndex = e
      this.$refs.chatFilesUploadButton.click()
    },
  },
}
</script>

<style lang="scss" scoped>
.menu__content:deep() {
  border-radius: 8px !important;
  box-shadow: 0px 0px 16px rgba(182, 182, 182, 0.4);
}
.addFile {
  line-height: 1;
}
</style>
